import { PaymentDetailsModel, LineItemModel } from './index';
import { TotalPriceInfoModel } from './../product/index';

export class CartModel {
  priceInfo: TotalPriceInfoModel;
  lineItems: LineItemModel[];

  paymentDetails: PaymentDetailsModel;
  fan: string;
  ban: string;
  ctn: string;
  isApplySame: boolean;
  orderId: string;
  productTnc: string;
}
